import React from 'react';
import BasicScreen from '../common/BasicScreen/BasicScreen';
import { useSelector } from 'react-redux';
import { applicationSelectors } from '../../redux/application';
import { Helmet } from 'react-helmet-async';
import { AccessibilityConfigView } from './components/AccessibilityConfigView';
import MarkdownViewer from '../../components/envago/MarkdownViewer/MarkdownViewer';
import './accessibility-custom-content.less'

const AccessibilityScreen = () => {
    const applicationName = useSelector(applicationSelectors.getApplicationName);

    const accessibilityConfig = useSelector(applicationSelectors.getAccessibilityConfig);
    const isCustomContent = accessibilityConfig?.customContent != null && accessibilityConfig?.customContent.trim() !== '';

    return (
        <BasicScreen>
            <Helmet>
                <title>{applicationName} | Barrierefreiheit</title>
            </Helmet>
            <div className={'accessibility-screen high-contrast max-w-screen-md mb-8'}>
                <h1 className={'text-3xl my-6'}>Barrierefreiheit</h1>

                {isCustomContent ? (
                    <MarkdownViewer light={true} text={accessibilityConfig?.customContent} className={'accessibility-custom-content'} />
                ) : (
                    <AccessibilityConfigView config={accessibilityConfig} />
                )}
            </div>
        </BasicScreen>
    );
};

export default AccessibilityScreen;
